const VERIFICATION_SENT_CONNECTION_KEY = "__ximaVerificationSentConnectionId";

const getSocketConnectionId = (socket) => String(socket?.id || "").trim();

export const emitSocketVerificationOnce = (socket, rawToken) => {
  if (!socket || typeof socket.emit !== "function") return false;

  const token = String(rawToken || "").trim();
  if (!token || token === "0") return false;

  const connectionId = getSocketConnectionId(socket);
  if (!connectionId) return false;
  if (socket[VERIFICATION_SENT_CONNECTION_KEY] === connectionId) return false;

  socket.emit("verify", token);
  socket[VERIFICATION_SENT_CONNECTION_KEY] = connectionId;
  return true;
};

